__webpack_require__.p = "/drink_Master-React_Node-frontend/";